export default __webpack_public_path__ + "static/nftberlin-3ae807794d6684d69205382e6e04edd1.png";